import "ngstorage";

import {REFERENCE_SCREENS} from "../../variables";

class ConfirmationController {
  constructor($localStorage, $window, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "confirmation";
    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.referenceScreens = REFERENCE_SCREENS;
  }

  $onInit() {
    console.log("init");
    console.dir(this.event);
    console.dir(this.sessionData);
  }

  goNext(type) {
    if (type === "PERSONAL") {
      //TODO: figure out what to do
      this.$window.open('https://link.jobble.com/KjBiGIAyINb', '_blank');
    } else {
      this.$window.open('https://meetings.hubspot.com/corey2/round-robin-to-sales?uuid=13de8d00-b084-4a64-8ae7-c36f3fb54a04', '_blank');
      this.triggerSlackNotifcation();
    }
  }

  triggerSlackNotifcation() {

    let rid = this.event.rid;

    this.$events.notifyBusinessOfInterestedReference(rid).then((r) => {
      console.log("Notified sales team:", r);
    }).catch((err) => {
      console.error(err);
    });

  }

}

ConfirmationController.$inject = [
  "$localStorage",
  "$window",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default ConfirmationController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/confirmation/confirmation.controller.js